import ClipLoader from 'react-spinners/ClipLoader';

function Loading({isLoading}) {
  return (
    <>
    {isLoading ? (
        <div className="raleway bg-[#00000070] z-50 w-[100%] h-[100%] flex justify-center items-center absolute right-0 bottom-0   top-0 left-0 m-auto rounded-md   ">
          <div className="h-[100px] relative px-6 pt-6 pb-3  text-3xl  mx-auto">
            
          
         <div className="mx-auto w-[100px]">  <ClipLoader
          color="#ffffff"
          size={60}/></div>
        
          </div>
        </div>
      ) : null}
      </>
  )
}

export default Loading